import {
	noCategorySelected,
	noVendorSelected,
	noDepartmentSelected,
} from "../constants"
import { RequestParameters } from "../interfaces"

export type FieldFilters = keyof RequestParameters
type ErrorMessage = { name: string; message: string }

const errorMessages: Partial<Record<keyof RequestParameters, ErrorMessage>> = {
	vendors: noVendorSelected,
	departments: noDepartmentSelected,
	categories: noCategorySelected,
}
const getFilterWithoutSelect = (filtersToValidate: Array<FieldFilters>) => (
	filters: RequestParameters
): Array<FieldFilters> =>
	filtersToValidate.filter((key) => {
		const value = filters[key]

		if (value === undefined) return true

		return value.length === 0
	})
export const validateFilters = (
	filters: RequestParameters,
	restricted: Array<FieldFilters>
) => {
	const hasValidFilters = getFilterWithoutSelect(restricted)
	const [firstInvalidFilter] = hasValidFilters(filters)
	return errorMessages[firstInvalidFilter]
}
